import { render, staticRenderFns } from "./WonderJyJy.vue?vue&type=template&id=70a7e966"
import script from "./WonderJyJy.vue?vue&type=script&lang=js"
export * from "./WonderJyJy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports